import { EventPart } from '@hopin-team/api-hopin';
import { SpaceProps } from '@hopin-team/ui-helper-with-space';
import { Icon } from '@hopin-team/ui-icon';
import React from 'react';

import { eventPartIcons } from '../EventPartTag';
import { CustomSegmentIcon } from '../Item';

export const EventPartIcon: React.FC<
  {
    eventPartType: EventPart;
    eventPartLabel?: string;
    customEventPartIcon?: string;
  } & SpaceProps
> = ({ eventPartType, eventPartLabel, customEventPartIcon, ...rest }) => {
  const icon = eventPartIcons[eventPartType]?.icon;

  if (eventPartType === 'custom' && customEventPartIcon) {
    return (
      <CustomSegmentIcon
        data-testid="custom-area-icon"
        src={customEventPartIcon}
        alt={eventPartLabel}
        aria-hidden="true"
      />
    );
  }

  return icon ? (
    <Icon name={icon} color="grey-500" aria-hidden="true" {...rest} />
  ) : null;
};
